import React, {
  useEffect,
  createContext,
  useReducer,
  useCallback,
} from "react";
import { useHistory } from "react-router-dom";

const TicketsContext = createContext();

const ticketsReducer = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_TICKET":
      if (
        state.currentTicket?.id === action.payload?.id &&
        state.currentTicket?.uuid === action.payload?.uuid &&
        state.currentTicket?.code === action.payload?.code &&
        state.currentTicket?.status === action.payload?.status &&
        state.currentTicket?.userId === action.payload?.userId
      ) {
        return state;
      }
      return { ...state, currentTicket: action.payload };
    case "SET_TAB_OPEN":
      if (state.tabOpen === action.payload) {
        return state;
      }
      return { ...state, tabOpen: action.payload };
    default:
      return state;
  }
};

const TicketsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ticketsReducer, {
    currentTicket: { id: null, code: null },
    tabOpen: "open",
  });

  const setCurrentTicket = useCallback((ticket) => {
    dispatch({ type: "SET_CURRENT_TICKET", payload: ticket });
  }, []);

  const setTabOpen = useCallback((tab) => {
    dispatch({ type: "SET_TAB_OPEN", payload: tab });
  }, []);

  const history = useHistory();

  useEffect(() => {
    if (
      state.currentTicket?.id !== null &&
      state.currentTicket?.uuid &&
      state.currentTicket?.status !== "closed"
    ) {
      const currentPath = history.location?.pathname || "";
      const currentSearch = history.location?.search || "";
      const nextPath = `/tickets/${state.currentTicket.uuid}`;
      if (
        currentPath !== nextPath &&
        (currentPath === "/tickets" || currentPath.startsWith("/tickets/"))
      ) {
        history.push({
          pathname: nextPath,
          search: currentSearch,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.currentTicket]);

  return (
    <TicketsContext.Provider
      value={{
        currentTicket: state.currentTicket,
        setCurrentTicket,
        tabOpen: state.tabOpen,
        setTabOpen,
      }}
    >
      {children}
    </TicketsContext.Provider>
  );
};

export { TicketsContext, TicketsContextProvider };
